import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Icon,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Colours } from '../common/constants';

const AccordionItem = ({ item, isExpanded, onToggle, auth, subItems }) => (
  <li>
    <Accordion
      expanded={isExpanded}
      onChange={onToggle}
      style={{
        backgroundColor: 'transparent',
        boxShadow:       'none',
        margin:          0,
      }}
      className="app-sidebar-accordion"
    >
      <AccordionSummary
        expandIcon={(
          <ExpandMoreIcon style={{
            color: Colours.White,
          }}
          />
        )}
        id={`accordion-header-${item.label}`}
        style={{
          padding:   '0px 24px',
          minHeight: 'auto',
          margin:    0,
        }}
        className="app-sidebar-nav-link"
      >
        <div style={{
          display:    'flex',
          alignItems: 'center',
          width:      '100%',
          color:      '#e1e2e3',
        }}
        >
          <Icon className="material-icons" style={{ fontSize: 16 }}>{item.icon}</Icon>
          <span style={{ marginLeft: 15, flex: 1 }}>{item.label}</span>
        </div>
      </AccordionSummary>
      <AccordionDetails style={{
        padding: 0,
        display: 'block',
      }}
      >
        <ul style={{ margin: 0, padding: 0, listStyleType: 'none' }}>
          {subItems.map((subItem) => {
            const subDisplay = auth && auth.user && auth.user.acl && auth.user.acl.includes(subItem.ac);
            return subDisplay ? (
              <li key={subItem.label}>
                <NavLink
                  to={subItem.link}
                  style={{
                    display:        'flex',
                    padding:        '12px 16px',
                    color:          '#e1e2e3',
                    textDecoration: 'none',
                  }}
                  activeStyle={{
                    color:           '#2b957a',
                    backgroundColor: '#383d4e',
                    borderLeft:      'solid 3px #2b957a',
                    padding:         '12px 12px',
                  }}
                >
                  <Icon className="material-icons">{subItem.icon}</Icon>
                  <span style={{ marginLeft: 15 }}>{subItem.label}</span>
                </NavLink>
              </li>
            ) : null;
          })}
        </ul>
      </AccordionDetails>
    </Accordion>
  </li>
);

AccordionItem.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string.isRequired,
    icon:  PropTypes.string.isRequired,
  }).isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onToggle:   PropTypes.func.isRequired,
  auth:       PropTypes.shape({
    user: PropTypes.shape({
      acl: PropTypes.arrayOf(PropTypes.string),
    }),
  }).isRequired,
  subItems: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default AccordionItem;
